// extracted by mini-css-extract-plugin
module.exports = {"Brand":"Brand_Brand__17k_F","header":"Brand_header__1Hz-t","Border":"Brand_Border__24z0Z","footer":"Brand_footer__19B0x"};